<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div v-if="generalErrorMessage" class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <b-card v-if="step === 1">
          <div class="episode-summary p-4">
            <div class="episode-summary-header">
              Available Episode Funds
              <h5>${{ formatNumber(paymentDistribution.availableFunds)}}</h5>
            </div>
            <div class="episode-summary-divide">
            </div>
            <div class="episode-summary-header">
              Service Allocation
              <h5>${{ formatNumber(paymentDistributionService.originalAmount) }}</h5>
            </div>
            <div class="episode-summary-divide">
            </div>
            <div class="episode-summary-header">
              Previously Paid
              <h5>${{ formatNumber(previouslyPaid) }}</h5>
            </div>
            <div class="episode-summary-divide">
            </div>
            <div class="episode-summary-header">
              Service Balance
              <h5 :class="{ 'text-danger': balanceAfterPayment < 0 }">${{ formatNumber(balanceAfterPayment) }}</h5>
            </div>
          </div>
        <div class="row">
          <div class="col-1">
          </div>
          <div class="col-10 mt-4">
            <b-form-group :label-cols="4" label="Participating Provider" label-align="right" :state="stateForField('organizationPayeeId')" :invalid-feedback="errorForField('organizationPayeeId')">
              <b-dropdown menu-class="dropdown-container" :text="payeeName"
                          :variant="hasError('organizationPayeeId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="payee in payees" :key="payee.organizationPayeeId"
                                 @click.prevent="setPayee(payee)">{{ payeeDisplayName(payee) }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group :label-cols="4" label="Account" label-align="right" :state="stateForField('organizationAccountId')" :invalid-feedback="errorForField('organizationAccountId')">
              <span v-if="accounts.length === 0 && payeeName !== 'Select Payee' ">
                <div class="account-label">No Account on File</div>
              </span>
              <span v-if="accounts.length === 1">
              <div class="account-label">{{ transfer.account.name + ' (' + transfer.account.last4 + ')' }}</div>
              </span>
              <span v-if="accounts && accounts.length > 1">
              <b-dropdown  menu-class="dropdown-container" :text="accountName"
                          :variant="hasError('organizationAccountId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="account in accounts" :key="account.organizationAccountId"
                                 @click.prevent="setAccount(account)">{{ account.name + ' (' + account.last4 + ')'  }}
                </b-dropdown-item>
              </b-dropdown>
              </span>
            </b-form-group>
            <b-form-group class="covered-services-amount" :label-cols="4" label="Covered Service Amount" label-align="right" :state="stateForField('amount')" :invalid-feedback="errorForField('amount')">
              <b-input-group class="covered-services-amount-input" prepend="$"><b-form-input v-model="transfer.amount"></b-form-input></b-input-group>
            </b-form-group>
          </div>
        </div>
        </b-card>
        <b-card v-if="step === 2">
          <div class="confirm-card">
            <div class="confirm-row">
              <span class="confirm-label">PROVIDER</span> {{ payeeName }}
            </div>
                <div class="confirm-row">
                  <span class="confirm-label">ACCOUNT</span>
                  <div>
                    <span>{{transfer.account.name}}</span>
                    <div v-if="hasError('organizationAccountId')" class="invalid-feedback d-block">{{ errorForField('organizationAccountId') }}</div>
                  </div>
                  </div>
            <div class="confirm-row">
              <span class="confirm-label">TAX ID</span> {{transfer.account.payee.taxId}}
            </div>
            <div class="confirm-row">
              <span class="confirm-label">NPI</span> {{transfer.account.payee.npi}}
            </div>
            <div class="confirm-row">
              <span class="confirm-label">PAYMENT AMOUNT</span> {{formatNumber(transfer.amount)}}
            </div>
          </div>
          <div class="pt-4">
            <font-awesome-icon size="sm" class="text-warning align-baseline mr-2" icon="exclamation-triangle"/>By submitting payment confirmation, the anchor provider attests covered services rendered are complete and documented.
          </div>
        </b-card>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button v-if="step === 1" type="button" class="btn btn-orange float-right" @click.prevent="confirmPayment()">Confirm Payment
      </button>
      <button  v-if="step === 2" type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Submit Payment
      </button>
      <button v-if="step === 2" type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="step--">Back to Edit</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'
  import _ from 'lodash'

  export default {
    name: 'PayDistributionModal',

    mixins: [ErrorsMixin],

    components: { },

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      paymentDistribution: {
        type: Object,
        required: false
      },

      paymentDistributionService: {
        type: Object,
        required: false
      },

      distributionAmount: {
        type: Number,
        required: true
      },

      bundleServiceId: {
        type: Number,
        required: false
      },
      bundleId: {
        type: Number,
        required: false
      },

      bundleServiceTypeId: {
        type: Number,
        required: false
      },

      account: {
        type: Object,
        required: false
      },

      payment: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        transfer: {
          organizationBundleServiceId: this.bundleServiceId,
          organizationBundleId: this.bundleId,
          organizationBundlePaymentDistributionServiceId: this.organizationBundlePaymentDistributionServiceId,
          amount: this.paymentDistributionService.originalAmount,
          organizationPayeeId: this.organizationPayeeId,
          bundleServiceTypeId: this.bundleServiceTypeId,
          organizationAccountId: this.organizationAccountId
        },
        distributionService: {},
        step: 1,
        payeeName: 'Select Participating Provider',
        accountName: 'Select Account',
        payees: [],
        accounts: [],
        isSaving: false,
        searchTerm: '',
        matchedCodes: [],
        currentAccount: {}
      }
    },

    watch: {
      paymentDistributionService (newValue, oldValue) {
        this.clearAllErrors()
        if (newValue !== oldValue && newValue) {
          this.distributionService = _.clone(this.paymentDistributionService)
          if (this.distributionService.totalPaid) {
            const remaining = this.distributionService.originalAmount - Math.abs(this.distributionService.totalPaid)
            this.transfer.amount = remaining > 0 ? parseFloat(remaining).toFixed(2) : '0.00'
          } else {
            this.transfer.amount = parseFloat(this.distributionService.originalAmount).toFixed(2)
          }
          this.transfer.organizationAccountId = 0
          if (this.currentAccount.payee) {
            this.payeeName = this.currentAccount.payee.businessName
          } else {
            this.payeeName = 'Select a participating provider'
          }
          this.transfer.organizationBundlePaymentDistributionServiceId = this.paymentDistributionService.organizationBundlePaymentDistributionServiceId
          this.accountName = 'Select Account'
          this.accounts = {}
          this.currentAccount = {}
        }
      },

      account: function (newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
          this.currentAccount = _.clone(newValue)
          this.transfer.account = _.clone(newValue)
          this.setPayee(this.currentAccount.payee)
          this.setAccount(this.currentAccount)
          this.accounts = this.payees.filter(payee => payee.organizationPayeeId === this.currentAccount.payee.organizationPayeeId)[0].accounts
        }
        if (newValue == null) {
          this.currentAccount = {}
          this.payeeName = 'Select Participating Provider'
          this.accountName = 'Select Account'
          this.transfer.account = {}
          this.transfer.organizationAccountId = 0
          this.accounts = {}
        }
      },
      visible (newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
          this.step = 1
          this.clearAllErrors()
          this.transfer.organizationBundleId = this.bundleId
          this.transfer.organizationBundleServiceId = this.bundleServiceId
          this.transfer.organizationBundlePaymentDistributionServiceId = this.paymentDistributionService.organizationBundlePaymentDistributionServiceId
          if (this.currentAccount && this.currentAccount.payee) {
            this.transfer.organizationPayeeId = this.currentAccount.payee.organizationPayeeId
            this.transfer.organizationAccountId = this.currentAccount.organizationAccountId
          }
          this.transfer.bundleService = this.bundleServiceTypeId
        }
      }
    },

    computed: {
      title () {
        if (this.paymentDistributionService && this.paymentDistributionService.bundleService && this.paymentDistributionService.bundleService.serviceType.name) {
          return 'Assign Provider for ' + this.paymentDistributionService.bundleService.serviceType.name + ' & Submit Payment'
        }

        return 'Assign Provider & Submit Payment'
      },
      previouslyPaid () {
        return Math.abs(this.paymentDistributionService.totalPaid || 0)
      },
      totalServiceAmountPaid () {
        return this.previouslyPaid + Number(this.transfer.amount)
      },
      balanceAfterPayment () {
        return this.paymentDistributionService.originalAmount - this.totalServiceAmountPaid
      }
    },

    methods: {
      confirmPayment () {
        if (this.validate()) {
          this.step++
        }
      },
      validate () {
        this.clearAllErrors()
        if (!this.transfer.amount) {
          this.addErrorForField('amount', 'You must enter an amount')
        }
        if (!this.transfer.account) {
          this.addErrorForField('organizationAccountId', 'You must select an account')
        }
        if (!this.transfer.organizationPayeeId) {
          this.addErrorForField('organizationPayeeId', 'You must select a payee')
        }

        return !this.hasErrors()
      },

      save () {
        if (this.isSaving === true) {
          return
        }
        if (!this.validate()) {
          return
        }
        this.clearAllErrors()
        this.isSaving = true
        const distributionId = this.paymentDistributionService.organizationBundlePaymentDistributionId
        const parameters = {
          organizationAccountId: this.transfer.organizationAccountId,
          organizationBundlePaymentDistributionServiceId: this.paymentDistributionService.organizationBundlePaymentDistributionServiceId,
          amount: parseFloat(this.transfer.amount)
        }
        api.post('/Dashboard/PaymentDistribution/' + distributionId + '/Pay', parameters).then(response => {
          this.$emit('paymentAdded')
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to fund payment distribution: ' + error.message, error)
          }
        })
          .finally(() => {
            this.isSaving = false
          })
      },

      formatNumber (number) {
        const value = Number(number)
        if (!isNaN(value)) {
          return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return '0.00'
      },

      loadPayees () {
        api.get('/Dashboard/Payees').then(response => {
          this.payees = response.data.filter(payee => payee.accounts.length > 0)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load payees: ' + error.message, error)
          }
        })
      },

      payeeDisplayName (payee) {
        if (payee.businessName && payee.businessName.trim() !== '') {
          return payee.businessName
        }

        const payeeUser = payee.users?.[0]?.user

        if (!payeeUser) {
          return 'Unknown Provider'
        }

        return `${payeeUser.firstName || ''} ${payeeUser.lastName || ''}`.trim()
      },

      closeModal () {
        this.$emit('update:visible', false)
      },

      setPayee (payee) {
        this.payeeName = this.payeeDisplayName(payee)
        this.transfer.organizationPayeeId = payee.organizationPayeeId
        this.accounts = payee.accounts
        if (this.accounts && this.accounts.length === 1) {
          this.setAccount(this.accounts[0])
        } else if (this.accounts && this.accounts.length > 1) {
          this.accountName = 'Select Account'
          this.transfer.account = null
        }
      },

      setAccount (account) {
        this.transfer.account = account
        this.transfer.organizationAccountId = account.organizationAccountId
        this.accountName = account.name + ' (' + account.last4 + ')'
      }
    },

    created () {
      this.loadPayees()
    }
  }
</script>

<style scoped>
.covered-services-amount-input {
  width: 60%;
}

.account-label {
  font-size: 1rem;
  margin-top: 6px;
}
.card {
  border: none;
}
.episode-summary {
  display: flex;
  justify-content: space-between;
  background-color: #f9f9f9;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}
.episode-summary-header {
  color: #2A84F4;
  font-weight:500;
  font-size: 17px;
}
h5 {
  color: #333333;
}
.episode-summary-divide {
  border: 0.5px solid #dee2e6;
}
.card-body {
  padding: 0;
}
.confirm-card {
  border-top: 0.5px solid #dee2e6;
  border-bottom: 0.5px solid #dee2e6;
}
.confirm-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 0.5px solid #dee2e6;
}

.confirm-row:last-child {
  border-bottom: none;
}
.confirm-label {
  font-weight: 500;
  text-transform: uppercase;
  color: #737284;
  width: 200px;
  flex-shrink: 0;
}
</style>
